import request from '@/router/axios'
export function GetMenu1(obj) {
  return request({
    url: '/menu/userMenu',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    params: obj

  })
}
export function GetMenu(obj) {
  return request({
    url: '/menu/userMenu',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    data: obj
  })
}
export function fetchTree(query) {
  return request({
    url: '/menu/allTree',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    params: query
  })
}

export function fetchAll() {
  return request({
    url: '/menu/navMenu',
    method: 'get'
  })
}

export function fetchUserTree() {
  return request({
    url: '/menu/userTree',
    method: 'get'
  })
}

export function addObj(obj) {
  return request({
    url: '/menu/add',
    method: 'post',
    params: obj
  })
}

export function getObj(id) {
  return request({
    url: '/menu/info',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    params: id
  })
}

export function delObj(id) {
  return request({
    url: '/menu/del',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    params: id
  })
}

export function putObj(obj) {
  return request({
    url: '/menu/update',
    method: 'post',
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    },
    params: obj
  })
}
